(function() {

  'use strict';

  function myFormatDate($filter) {
    if (!String.prototype.splice) {
      /**
       * {JSDoc}
       *
       * The splice() method changes the content of a string by removing a range of
       * characters and/or adding new characters.
       *
       * @this {String}
       * @param {number} start Index at which to start changing the string.
       * @param {number} delCount An integer indicating the number of old chars to remove.
       * @param {string} newSubStr The String that is spliced in.
       * @return {string} A new string with the spliced substring.
       */
      String.prototype.splice = function(start, delCount, newSubStr) {
        return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
      };
    }

    function toTitleCase(str) {
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }

    return function(timestamp, format) {
      var date = timestamp ? new Date(timestamp) : null;
      if (date) {
        var newFormat = format ? format : 'EEE, dd MMM';
        var dateFormated = $filter('date')(date, newFormat).split(' ');
        var day = toTitleCase(dateFormated[0]);
        var month = toTitleCase(dateFormated[2]);
        dateFormated[0] = day;
        dateFormated[2] = month;
        var stringFormated = dateFormated.toString().replace(new RegExp(',', 'g'), ' ');
        return stringFormated.splice(3, 0, ',');
      }

    }
  };

  angular.module('mandaeApp')
    .filter('myFormatDate', myFormatDate);

})();
